export const ROUND_RESULTS_TAB = "roundResults";
export const FIXTURES_TAB = "fixtures";
export const PAST_SEASON_RESULTS_TAB = "pastSeasonResults";

export const TABS = [
	ROUND_RESULTS_TAB,
	FIXTURES_TAB,
	PAST_SEASON_RESULTS_TAB,
];